import { Box, Divider, Paper, Stack } from '@mui/material'

import AnalystCreatedCounts from './AnalystCreatedCounts'
import MonthlyBasketsCreated from './MonthlyBasketsCreated'
import MonthlyTotalMatches from './MonthlyTotalMatches'
import MonthlyTotalSavings from './MonthlyTotalSavings'
import MonthlyTotalSpend from './MonthlyTotalSpend'
import SavingsPercentage from './SavingsPercentage'
import SixMonAvgStats from './SixMonAvgStats'
import TotalDailySavings from './TotalDailySavings'

export default function MarketBaskets() {
	return (
		<Box data-testid="market-baskets">
			<Stack spacing={4} sx={{ width: '100%' }}>
				<Paper elevation={1}>
					<Stack direction="row" spacing={1} p="1rem">
						<MonthlyBasketsCreated />
						<Divider orientation="vertical" flexItem />
						<MonthlyTotalSpend />
						<Divider orientation="vertical" flexItem />
						<MonthlyTotalMatches />
						<Divider orientation="vertical" flexItem />
						<MonthlyTotalSavings />
					</Stack>
				</Paper>

				<SavingsPercentage />

				<TotalDailySavings />

				<Stack direction="row" spacing={4}>
					<SixMonAvgStats />
					<AnalystCreatedCounts />
				</Stack>
			</Stack>
		</Box>
	)
}
